module.exports = __webpack_public_path__ + "static/Calibre-Regular-96e0a7c47fdd7a8f05007837ead73b35.ttf";